import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export type Profile = {
  id: number;
  emp_id: string;
  first_name: string;
  last_name: string;
  profile?: string;
  email: string;
  personal_email?: string;
  phone?: string;
  dob: string;
  date_of_joining: string;
};
export type ProfileStateType = {
  isLoading: boolean;
  errorProfileState: boolean | string;
  successProfileState: boolean | string;
  profileData: Profile | null;
};

const initialState: ProfileStateType = {
  isLoading: false,
  errorProfileState: false,
  successProfileState: false,
  profileData: null,
};

/*
 * get profile details
 */

export type getProfileDetailsSuccessResponse = {
  data: Profile;
  status_code: string;
};

/**
 * update profile details
 */

export type updateProfileDetailsParams = Pick<
  Profile,
  'phone' | 'personal_email'
>;

export type updateProfileDetailsResponse = {
  status_code: string;
  data: Profile;
};

const ProfileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    getProfileDetailsRequest(state, action: PayloadAction) {
      state.isLoading = true;
      state.errorProfileState = false;
    },
    getProfileDetailsSuccess(
      state,
      action: PayloadAction<getProfileDetailsSuccessResponse>,
    ) {
      state.isLoading = false;
      state.successProfileState = action.payload.status_code;
      state.profileData = action.payload.data;
    },
    getProfileDetailsFailure(state, action: PayloadAction<string | boolean>) {
      state.errorProfileState = action.payload;
      state.isLoading = false;
    },
    updateProfileDetailsRequest(
      state,
      action: PayloadAction<updateProfileDetailsParams>,
    ) {
      state.isLoading = true;
      state.errorProfileState = false;
    },
    updateProfileDetailsSuccess(
      state,
      action: PayloadAction<updateProfileDetailsResponse>,
    ) {
      state.isLoading = false;
      state.successProfileState = action.payload.status_code;
      state.profileData = action.payload.data;
    },
    updateProfileDetailsFailure(
      state,
      action: PayloadAction<string | boolean>,
    ) {
      state.errorProfileState = action.payload;
      state.isLoading = false;
    },
    resetMessage(state) {
      state.errorProfileState = false;
      state.successProfileState = false;
    },
  },
});

export default ProfileSlice.reducer;

export const {
  getProfileDetailsRequest,
  getProfileDetailsSuccess,
  getProfileDetailsFailure,
  updateProfileDetailsRequest,
  updateProfileDetailsSuccess,
  updateProfileDetailsFailure,
  resetMessage,
} = ProfileSlice.actions;
